export default __webpack_public_path__ + "427c392fd9a2712185d153f319fa0d29.svg";